/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import workastLogo from './workast-logo.svg';

const LogoWrapper = styled.img`
  width: ${props => props.size};
`;

const Logo = ({ size }) => (
  <LogoWrapper src={workastLogo} alt="logo" size={size} />
);

Logo.propTypes = {
  size: PropTypes.string,
};

Logo.defaultProps = {
  size: '3.125rem',
};

export default Logo;
